// import React, { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   Box,
//   Card,
//   CardContent,
//   Tabs,
//   Tab,
//   Typography,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   Button,
//   Link,
//   CircularProgress,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
// } from "@mui/material";
// import HistoryIcon from "@mui/icons-material/History";
// import DescriptionIcon from "@mui/icons-material/Description";
// import UploadFileIcon from "@mui/icons-material/UploadFile";
// import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
// import BackButton from "../../components/common/BackButton";
// import Loader from "../../components/common/Loader";
// import { SERVER_ORIGIN } from "../../utilities/constants";
// import { hasAdminAccess, getDashboardPath } from "../../utilities/helper_functions";
// import css from "../../css/admin/users-page.module.css";

// const getAdminAuthHeaders = () => {
//   const headers = {
//     "Content-Type": "application/json",
//     "auth-token": sessionStorage.getItem("token"),
//   };
//   const adminId = process.env.REACT_APP_ADMIN_ID || "yuva@gmail.com";
//   const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || "admin@yuva123";
//   headers.Authorization = `Basic ${btoa(`${adminId}:${adminPassword}`)}`;
//   return headers;
// };

// const formatDate = (d) => {
//   if (!d) return "-";
//   const date = new Date(d);
//   return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
// };

// const AuditHistoryPage = () => {
//   const navigate = useNavigate();
//   const [activeTab, setActiveTab] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [data, setData] = useState({
//     mouHistory: [],
//     studentUploads: [],
//     roleAssignments: [],
//     tcAndModifications: [],
//     total: 0,
//   });
//   const [filters, setFilters] = useState({
//     type: "",
//     dateFrom: "",
//     dateTo: "",
//     page: 1,
//     limit: 50,
//   });

//   const hasAdmin = hasAdminAccess();

//   useEffect(() => {
//     if (!hasAdmin) {
//       navigate("/admin/services");
//       return;
//     }
//     fetchAudit();
//   }, [hasAdmin, activeTab, filters]);

//   const fetchAudit = async () => {
//     setLoading(true);
//     try {
//       const typeMap = ["", "mou", "student_upload", "role_assignment", "tc_and_modifications"];
//       const type = typeMap[activeTab] || "";
//       const params = new URLSearchParams();
//       if (type) params.append("type", type);
//       if (filters.dateFrom) params.append("dateFrom", filters.dateFrom);
//       if (filters.dateTo) params.append("dateTo", filters.dateTo);
//       params.append("page", String(filters.page));
//       params.append("limit", String(filters.limit));

//       const res = await fetch(
//         `${SERVER_ORIGIN}/api/admin/auth/audit/history?${params.toString()}`,
//         { method: "GET", headers: getAdminAuthHeaders() }
//       );
//       const result = await res.json();
//       if (res.ok && result.data) {
//         setData(result.data);
//       } else {
//         setData({ mouHistory: [], studentUploads: [], roleAssignments: [], tcAndModifications: [], total: 0 });
//       }
//     } catch (err) {
//       console.error("Audit fetch error:", err);
//       setData({ mouHistory: [], studentUploads: [], roleAssignments: [], tcAndModifications: [], total: 0 });
//     }
//     setLoading(false);
//   };

//   const tabLabels = ["All", "MoU History", "Student Uploads", "Role Assignments", "T&C & Modifications"];

//   return (

//     <div className={css.outerDiv}>

//       <div className={css.headerSection}>
//         <div className={css.headerLeft}>
//           <BackButton
//             text="Back to Dashboard"
//             customPath={getDashboardPath()}
//           />
//         </div>
//       </div>
//       {/* <BackButton onClick={() => navigate("/admin/services")} /> */}
//       <Card sx={{ mb: 2 }}>
//         <CardContent>
//           <Typography variant="h5" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
//             <HistoryIcon /> Audit & History
//           </Typography>
//           <Typography variant="body2" color="text.secondary">
//             View historical MoUs, student uploads, and role assignments for audit and reference.
//           </Typography>
//         </CardContent>
//       </Card>

//       <Card>
//         <Tabs
//           value={activeTab}
//           onChange={(_, v) => { setActiveTab(v); setFilters((f) => ({ ...f, page: 1 })); }}
//           sx={{ borderBottom: 1, borderColor: "divider", px: 1 }}
//           variant="scrollable"
//           scrollButtons="auto"
//         >
//           <Tab label="All" />
//           <Tab label="MoU History" icon={<DescriptionIcon />} iconPosition="start" />
//           <Tab label="Student Uploads" icon={<UploadFileIcon />} iconPosition="start" />
//           <Tab label="Role Assignments" icon={<AssignmentIndIcon />} iconPosition="start" />
//           <Tab label="T&C & Modifications" />
//         </Tabs>
//         <CardContent>
//           <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
//             <TextField
//               size="small"
//               type="date"
//               label="From date"
//               InputLabelProps={{ shrink: true }}
//               value={filters.dateFrom}
//               onChange={(e) => setFilters((f) => ({ ...f, dateFrom: e.target.value, page: 1 }))}
//             />
//             <TextField
//               size="small"
//               type="date"
//               label="To date"
//               InputLabelProps={{ shrink: true }}
//               value={filters.dateTo}
//               onChange={(e) => setFilters((f) => ({ ...f, dateTo: e.target.value, page: 1 }))}
//             />
//             <Button variant="outlined" onClick={fetchAudit}>Apply</Button>
//             <Button
//               variant="outlined"
//               color="secondary"
//               onClick={clearFilters}
//               sx={{ minWidth: '100px' }}
//             >
//               Clear
//             </Button>
//           </Box>

//           {loading ? (
//             <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
//               <Loader />
//             </Box>
//           ) : (
//             <>
//               {activeTab === 0 && (
//                 <Box>
//                   <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>MoU History (recent)</Typography>
//                   <TableContainer component={Paper} sx={{ mb: 3 }}>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow>
//                           <TableCell>Institute</TableCell>
//                           <TableCell>Sign Date</TableCell>
//                           <TableCell>Duration</TableCell>
//                           <TableCell>Status</TableCell>
//                           {/* <TableCell>Link</TableCell> */}
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {(data.mouHistory || []).slice(0, 20).map((row, i) => (
//                           <TableRow key={i}>
//                             <TableCell>{row.instituteName}</TableCell>
//                             <TableCell>{formatDate(row.signDate)}</TableCell>
//                             <TableCell>{row.mouDuration || "-"}</TableCell>
//                             <TableCell>{row.mouStatus || "-"}</TableCell>
//                             {/* <TableCell>
//                               {row.mouUrl ? (
//                                 <Link href={row.mouUrl} target="_blank" rel="noopener noreferrer">View</Link>
//                               ) : "-"}
//                             </TableCell> */}
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                   <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>Student Uploads (recent)</Typography>
//                   <TableContainer component={Paper} sx={{ mb: 3 }}>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow>
//                           <TableCell>Institute</TableCell>
//                           <TableCell>Uploaded At</TableCell>
//                           <TableCell>File / Rows</TableCell>
//                           {/* <TableCell>Uploaded By</TableCell> */}
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {(data.studentUploads || []).slice(0, 20).map((row) => (
//                           <TableRow key={row._id}>
//                             <TableCell>{row.instituteName}</TableCell>
//                             <TableCell>{formatDate(row.uploadedAt)}</TableCell>
//                             <TableCell>{row.fileName || "-"} / {row.rowCount ?? 0}</TableCell>
//                             {/* <TableCell>{row.uploadedByEmail || "-"}</TableCell> */}
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                   <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>Role Assignments (recent)</Typography>
//                   <TableContainer component={Paper}>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow>
//                           <TableCell>Date</TableCell>
//                           <TableCell>Action</TableCell>
//                           <TableCell>User / Role</TableCell>
//                           <TableCell>Details</TableCell>
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {(data.roleAssignments || []).slice(0, 20).map((row) => (
//                           <TableRow key={row._id}>
//                             <TableCell>{formatDate(row.createdAt)}</TableCell>
//                             <TableCell>{row.actionType}</TableCell>
//                             <TableCell>{row.userEmail} / {row.roleChanges?.newRole || "-"}</TableCell>
//                             <TableCell>
//                               {row.actionDetails?.collegeName && `${row.actionDetails.collegeName}`}
//                               {row.actionDetails?.effectiveFrom && ` (${formatDate(row.actionDetails.effectiveFrom)} - ${formatDate(row.actionDetails.effectiveTo)})`}
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Box>
//               )}
//               {activeTab === 1 && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Institute</TableCell>
//                         <TableCell>Sign Date</TableCell>
//                         <TableCell>Duration</TableCell>
//                         <TableCell>Status</TableCell>
//                         <TableCell>Link</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {(data.mouHistory || []).map((row, i) => (
//                         <TableRow key={i}>
//                           <TableCell>{row.instituteName}</TableCell>
//                           <TableCell>{formatDate(row.signDate)}</TableCell>
//                           <TableCell>{row.mouDuration || "-"}</TableCell>
//                           <TableCell>{row.mouStatus || "-"}</TableCell>
//                           <TableCell>
//                             {row.mouUrl ? (
//                               <Link href={row.mouUrl} target="_blank" rel="noopener noreferrer">View</Link>
//                             ) : "-"}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.mouHistory?.length ?? 0}</Typography>
//                 </TableContainer>
//               )}
//               {activeTab === 2 && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Institute</TableCell>
//                         <TableCell>Uploaded At</TableCell>
//                         <TableCell>File / Rows</TableCell>
//                         <TableCell>Uploaded By</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {(data.studentUploads || []).map((row) => (
//                         <TableRow key={row._id}>
//                           <TableCell>{row.instituteName}</TableCell>
//                           <TableCell>{formatDate(row.uploadedAt)}</TableCell>
//                           <TableCell>{row.fileName || "-"} / {row.rowCount ?? 0}</TableCell>
//                           <TableCell>{row.uploadedByEmail || "-"}</TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.studentUploads?.length ?? 0}</Typography>
//                 </TableContainer>
//               )}
//               {activeTab === 3 && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Date</TableCell>
//                         <TableCell>Action</TableCell>
//                         <TableCell>User / Role</TableCell>
//                         <TableCell>Details</TableCell>
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {(data.roleAssignments || []).map((row) => (
//                         <TableRow key={row._id}>
//                           <TableCell>{formatDate(row.createdAt)}</TableCell>
//                           <TableCell>{row.actionType}</TableCell>
//                           <TableCell>{row.userEmail} / {row.roleChanges?.newRole || "-"}</TableCell>
//                           <TableCell>
//                             {row.actionDetails?.collegeName && `${row.actionDetails.collegeName}`}
//                             {row.actionDetails?.effectiveFrom && ` (${formatDate(row.actionDetails.effectiveFrom)} - ${formatDate(row.actionDetails.effectiveTo)})`}
//                           </TableCell>
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.roleAssignments?.length ?? 0}</Typography>
//                 </TableContainer>
//               )}
//               {activeTab === 4 && (
//                 <TableContainer component={Paper}>
//                   <Table size="small">
//                     <TableHead>
//                       <TableRow>
//                         <TableCell>Date</TableCell>
//                         <TableCell>Action</TableCell>
//                         <TableCell>User ID / Email</TableCell>
//                         <TableCell>IP</TableCell>
//                         <TableCell>T&C Date / Role / Details</TableCell>
//                         {/* <TableCell>Changes</TableCell> */}
//                       </TableRow>
//                     </TableHead>
//                     <TableBody>
//                       {(data.tcAndModifications || []).map((row) => (
//                         <TableRow key={row._id}>
//                           <TableCell>{formatDate(row.createdAt)}</TableCell>
//                           <TableCell>{row.actionType}</TableCell>
//                           <TableCell>
//                             {row.userId ? String(row.userId).slice(-8) : "-"} / {row.userEmail || "-"}
//                           </TableCell>
//                           <TableCell>{row.ipAddress || "-"}</TableCell>
//                           <TableCell>
//                             {row.actionType === "TERMS_ACCEPTANCE" && formatDate(row.termsAcceptanceDate)}
//                             {row.actionType === "ROLE_ASSIGNMENT" && row.roleChanges?.newRole}
//                             {row.actionType === "MOU_APPROVAL" && (row.actionDetails?.mouStatus || "-")}
//                             {row.actionDetails?.instituteName && ` · ${row.actionDetails.instituteName}`}
//                           </TableCell>
//                           {/* <TableCell>
//                             {Array.isArray(row.changes) && row.changes.length
//                               ? row.changes.map((c, i) => `${c.field}: ${String(c.oldValue)}→${String(c.newValue)}`).join("; ")
//                               : "-"}
//                           </TableCell> */}
//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                   <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.tcAndModifications?.length ?? 0}</Typography>
//                 </TableContainer>
//               )}
//             </>
//           )}
//         </CardContent>
//       </Card>
//     </div>
//   );
// };

// export default AuditHistoryPage;


import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Card,
  CardContent,
  Tabs,
  Tab,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Button,
  Link,
  CircularProgress,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import HistoryIcon from "@mui/icons-material/History";
import DescriptionIcon from "@mui/icons-material/Description";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import BackButton from "../../components/common/BackButton";
import Loader from "../../components/common/Loader";
import { SERVER_ORIGIN } from "../../utilities/constants";
import { hasAdminAccess, getDashboardPath } from "../../utilities/helper_functions";
import css from "../../css/admin/users-page.module.css";

const getAdminAuthHeaders = () => {
  const headers = {
    "Content-Type": "application/json",
    "auth-token": sessionStorage.getItem("token"),
  };
  const adminId = process.env.REACT_APP_ADMIN_ID || "yuva@gmail.com";
  const adminPassword = process.env.REACT_APP_ADMIN_PASSWORD || "admin@yuva123";
  headers.Authorization = `Basic ${btoa(`${adminId}:${adminPassword}`)}`;
  return headers;
};

const formatDate = (d) => {
  if (!d) return "-";
  const date = new Date(d);
  return isNaN(date.getTime()) ? "-" : date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
};

const AuditHistoryPage = () => {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({
    mouHistory: [],
    studentUploads: [],
    roleAssignments: [],
    tcAndModifications: [],
    total: 0,
  });
  const [filters, setFilters] = useState({
    type: "",
    dateFrom: "",
    dateTo: "",
    page: 1,
    limit: 50,
  });

  const hasAdmin = hasAdminAccess();

  useEffect(() => {
    if (!hasAdmin) {
      navigate("/admin/services");
      return;
    }
    fetchAudit();
  }, [hasAdmin, activeTab, filters]);

  const fetchAudit = async () => {
    setLoading(true);
    try {
      const typeMap = ["", "mou", "student_upload", "role_assignment", "tc_and_modifications"];
      const type = typeMap[activeTab] || "";
      const params = new URLSearchParams();
      if (type) params.append("type", type);
      if (filters.dateFrom) params.append("dateFrom", filters.dateFrom);
      if (filters.dateTo) params.append("dateTo", filters.dateTo);
      params.append("page", String(filters.page));
      params.append("limit", String(filters.limit));

      const res = await fetch(
        `${SERVER_ORIGIN}/api/admin/auth/audit/history?${params.toString()}`,
        { method: "GET", headers: getAdminAuthHeaders() }
      );
      const result = await res.json();
      if (res.ok && result.data) {
        setData(result.data);
      } else {
        setData({ mouHistory: [], studentUploads: [], roleAssignments: [], tcAndModifications: [], total: 0 });
      }
    } catch (err) {
      console.error("Audit fetch error:", err);
      setData({ mouHistory: [], studentUploads: [], roleAssignments: [], tcAndModifications: [], total: 0 });
    }
    setLoading(false);
  };

  // Clear filters function
  const clearFilters = () => {
    setFilters({
      type: "",
      dateFrom: "",
      dateTo: "",
      page: 1,
      limit: 50,
    });
    // Note: No need to call fetchAudit here as useEffect will trigger with updated filters
  };

  const tabLabels = ["All", "MoU History", "Student Uploads", "Role Assignments", "T&C & Modifications"];

  return (

    <div className={css.outerDiv}>

      <div className={css.headerSection}>
        <div className={css.headerLeft}>
          <BackButton
            text="Back to Dashboard"
            customPath={getDashboardPath()}
          />
        </div>
      </div>
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h5" sx={{ display: "flex", alignItems: "center", gap: 1, mb: 2 }}>
            <HistoryIcon /> Audit & History
          </Typography>
          <Typography variant="body2" color="text.secondary">
            View historical MoUs, student uploads, and role assignments for audit and reference.
          </Typography>
        </CardContent>
      </Card>

      <Card>
        <Tabs
          value={activeTab}
          onChange={(_, v) => { setActiveTab(v); setFilters((f) => ({ ...f, page: 1 })); }}
          sx={{ borderBottom: 1, borderColor: "divider", px: 1 }}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="All" />
          <Tab label="MoU History" icon={<DescriptionIcon />} iconPosition="start" />
          <Tab label="Student Uploads" icon={<UploadFileIcon />} iconPosition="start" />
          <Tab label="Role Assignments" icon={<AssignmentIndIcon />} iconPosition="start" />
          <Tab label="T&C & Modifications" />
        </Tabs>
        <CardContent>
          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mb: 2 }}>
            <TextField
              size="small"
              type="date"
              label="From date"
              InputLabelProps={{ shrink: true }}
              value={filters.dateFrom}
              onChange={(e) => setFilters((f) => ({ ...f, dateFrom: e.target.value, page: 1 }))}
            />
            <TextField
              size="small"
              type="date"
              label="To date"
              InputLabelProps={{ shrink: true }}
              value={filters.dateTo}
              onChange={(e) => setFilters((f) => ({ ...f, dateTo: e.target.value, page: 1 }))}
            />
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="outlined"
                onClick={fetchAudit}
                sx={{ minWidth: '100px' }}
              >
                Apply
              </Button>
              <Button
                variant="outlined"
                color="secondary"
                onClick={clearFilters}
                sx={{ minWidth: '100px' }}
              >
                Clear
              </Button>
            </Box>
          </Box>

          {loading ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 4 }}>
              <Loader />
            </Box>
          ) : (
            <>
              {activeTab === 0 && (
                <Box>
                  <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>MoU History (recent)</Typography>
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Institute</TableCell>
                          <TableCell>Sign Date</TableCell>
                          <TableCell>Duration</TableCell>
                          <TableCell>Status</TableCell>
                          {/* <TableCell>Link</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(data.mouHistory || []).slice(0, 20).map((row, i) => (
                          <TableRow key={i}>
                            <TableCell>{row.instituteName}</TableCell>
                            <TableCell>{formatDate(row.signDate)}</TableCell>
                            <TableCell>{row.mouDuration || "-"}</TableCell>
                            <TableCell>{row.mouStatus || "-"}</TableCell>
                            {/* <TableCell>
                              {row.mouUrl ? (
                                <Link href={row.mouUrl} target="_blank" rel="noopener noreferrer">View</Link>
                              ) : "-"}
                            </TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>Student Uploads (recent)</Typography>
                  <TableContainer component={Paper} sx={{ mb: 3 }}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Institute</TableCell>
                          <TableCell>Uploaded At</TableCell>
                          <TableCell>File / Rows</TableCell>
                          {/* <TableCell>Uploaded By</TableCell> */}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(data.studentUploads || []).slice(0, 20).map((row) => (
                          <TableRow key={row._id}>
                            <TableCell>{row.instituteName}</TableCell>
                            <TableCell>{formatDate(row.uploadedAt)}</TableCell>
                            <TableCell>{row.fileName || "-"} / {row.rowCount ?? 0}</TableCell>
                            {/* <TableCell>{row.uploadedByEmail || "-"}</TableCell> */}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                  <Typography variant="subtitle1" sx={{ mt: 1, mb: 1 }}>Role Assignments (recent)</Typography>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Date</TableCell>
                          <TableCell>Action</TableCell>
                          <TableCell>User / Role</TableCell>
                          <TableCell>Details</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(data.roleAssignments || []).slice(0, 20).map((row) => (
                          <TableRow key={row._id}>
                            <TableCell>{formatDate(row.createdAt)}</TableCell>
                            <TableCell>{row.actionType}</TableCell>
                            <TableCell>{row.userEmail} / {row.roleChanges?.newRole || "-"}</TableCell>
                            <TableCell>
                              {row.actionDetails?.collegeName && `${row.actionDetails.collegeName}`}
                              {row.actionDetails?.effectiveFrom && ` (${formatDate(row.actionDetails.effectiveFrom)} - ${formatDate(row.actionDetails.effectiveTo)})`}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              )}
              {activeTab === 1 && (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Institute</TableCell>
                        <TableCell>Sign Date</TableCell>
                        <TableCell>Duration</TableCell>
                        <TableCell>Status</TableCell>
                        <TableCell>Link</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.mouHistory || []).map((row, i) => (
                        <TableRow key={i}>
                          <TableCell>{row.instituteName}</TableCell>
                          <TableCell>{formatDate(row.signDate)}</TableCell>
                          <TableCell>{row.mouDuration || "-"}</TableCell>
                          <TableCell>{row.mouStatus || "-"}</TableCell>
                          <TableCell>
                            {row.mouUrl ? (
                              <Link href={row.mouUrl} target="_blank" rel="noopener noreferrer">View</Link>
                            ) : "-"}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.mouHistory?.length ?? 0}</Typography>
                </TableContainer>
              )}
              {activeTab === 2 && (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Institute</TableCell>
                        <TableCell>Uploaded At</TableCell>
                        <TableCell>File / Rows</TableCell>
                        <TableCell>Uploaded By</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.studentUploads || []).map((row) => (
                        <TableRow key={row._id}>
                          <TableCell>{row.instituteName}</TableCell>
                          <TableCell>{formatDate(row.uploadedAt)}</TableCell>
                          <TableCell>{row.fileName || "-"} / {row.rowCount ?? 0}</TableCell>
                          <TableCell>{row.uploadedByEmail || "-"}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.studentUploads?.length ?? 0}</Typography>
                </TableContainer>
              )}
              {activeTab === 3 && (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Action</TableCell>
                        <TableCell>User / Role</TableCell>
                        <TableCell>Details</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.roleAssignments || []).map((row) => (
                        <TableRow key={row._id}>
                          <TableCell>{formatDate(row.createdAt)}</TableCell>
                          <TableCell>{row.actionType}</TableCell>
                          <TableCell>{row.userEmail} / {row.roleChanges?.newRole || "-"}</TableCell>
                          <TableCell>
                            {row.actionDetails?.collegeName && `${row.actionDetails.collegeName}`}
                            {row.actionDetails?.effectiveFrom && ` (${formatDate(row.actionDetails.effectiveFrom)} - ${formatDate(row.actionDetails.effectiveTo)})`}
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.roleAssignments?.length ?? 0}</Typography>
                </TableContainer>
              )}
              {activeTab === 4 && (
                <TableContainer component={Paper}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Date</TableCell>
                        <TableCell>Action</TableCell>
                        <TableCell>User ID / Email</TableCell>
                        <TableCell>IP</TableCell>
                        <TableCell>T&C Date / Role / Details</TableCell>
                        {/* <TableCell>Changes</TableCell> */}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(data.tcAndModifications || []).map((row) => (
                        <TableRow key={row._id}>
                          <TableCell>{formatDate(row.createdAt)}</TableCell>
                          <TableCell>{row.actionType}</TableCell>
                          <TableCell>
                            {row.userId ? String(row.userId).slice(-8) : "-"} / {row.userEmail || "-"}
                          </TableCell>
                          <TableCell>{row.ipAddress || "-"}</TableCell>
                          <TableCell>
                            {row.actionType === "TERMS_ACCEPTANCE" && formatDate(row.termsAcceptanceDate)}
                            {row.actionType === "ROLE_ASSIGNMENT" && row.roleChanges?.newRole}
                            {row.actionType === "MOU_APPROVAL" && (row.actionDetails?.mouStatus || "-")}
                            {row.actionDetails?.instituteName && ` · ${row.actionDetails.instituteName}`}
                          </TableCell>
                          {/* <TableCell>
                            {Array.isArray(row.changes) && row.changes.length
                              ? row.changes.map((c, i) => `${c.field}: ${String(c.oldValue)}→${String(c.newValue)}`).join("; ")
                              : "-"}
                          </TableCell> */}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>Total: {data.total ?? data.tcAndModifications?.length ?? 0}</Typography>
                </TableContainer>
              )}
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default AuditHistoryPage;
